module.exports = __webpack_public_path__ + "img/valentine-light-medium.0b68ad47.svg";